/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_EmailInputs */

const th_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมล`)
};

const en_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const ja_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

const zh_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮箱`)
};

const es_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección de correo`)
};

const pt_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail`)
};

const id_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email`)
};

const fr_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail`)
};

const tl_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const vi_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ email`)
};

const ko_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소`)
};

const de_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const ru_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты`)
};

const tr_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresi`)
};

const it_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo email`)
};

const pl_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres e-mail`)
};

const uk_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адреса електронної пошти`)
};

const hi_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल पता`)
};

const ar_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني`)
};

const ms_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat e-mel`)
};

const bn_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইমেল ঠিকানা`)
};

const zh_tw2_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件`)
};

const zh_hk2_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件`)
};

const ur_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ای میل پتہ`)
};

const fa_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشانی ایمیل`)
};

const sw_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwani ya barua pepe`)
};

const nl_invite_email = /** @type {(inputs: Invite_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Invite_EmailInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_email = /** @type {((inputs?: Invite_EmailInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_EmailInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invite_email(inputs)
	if (locale === "ja") return ja_invite_email(inputs)
	if (locale === "zh") return zh_invite_email(inputs)
	if (locale === "es") return es_invite_email(inputs)
	if (locale === "pt") return pt_invite_email(inputs)
	if (locale === "id") return id_invite_email(inputs)
	if (locale === "fr") return fr_invite_email(inputs)
	if (locale === "tl") return tl_invite_email(inputs)
	if (locale === "vi") return vi_invite_email(inputs)
	if (locale === "ko") return ko_invite_email(inputs)
	if (locale === "de") return de_invite_email(inputs)
	if (locale === "ru") return ru_invite_email(inputs)
	if (locale === "tr") return tr_invite_email(inputs)
	if (locale === "it") return it_invite_email(inputs)
	if (locale === "pl") return pl_invite_email(inputs)
	if (locale === "uk") return uk_invite_email(inputs)
	if (locale === "hi") return hi_invite_email(inputs)
	if (locale === "ar") return ar_invite_email(inputs)
	if (locale === "ms") return ms_invite_email(inputs)
	if (locale === "bn") return bn_invite_email(inputs)
	if (locale === "zh-TW") return zh_tw2_invite_email(inputs)
	if (locale === "zh-HK") return zh_hk2_invite_email(inputs)
	if (locale === "ur") return ur_invite_email(inputs)
	if (locale === "fa") return fa_invite_email(inputs)
	if (locale === "sw") return sw_invite_email(inputs)
	if (locale === "nl") return nl_invite_email(inputs)
	return en_invite_email(inputs)
});